import React from 'react';
import {Route , Link} from 'react-router-dom';
import { CurrencySelector } from '../../_components';
import { ExchangePage } from '../ExchangePage';
import { currencyServices , transactionService } from '../../_services'
import { connect } from 'react-redux';
import request from 'superagent';
import { utils} from '../../_helpers';
import ReactTable from "react-table";
import QRCode from 'qrcode.react';
import 'react-table/react-table.css'
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/flip.css';

class GetHWGCashPage extends React.Component{
    
    constructor(props){
        super(props);

        this.state = {
            amount : '',  
            conversion : '' , 
            walletUSD : '0' , 
            list : [] ,
            pages : 0 , 
            list_loading : true ,
            disableSubmit : false
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleHWGCashChange = this.handleHWGCashChange.bind(this);
        this.handleCurrencyDropdown = this.handleCurrencyDropdown.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUploadFile = this.handleUploadFile.bind(this);
        this.onFetchData = this.onFetchData.bind(this);
    }


    componentWillReceiveProps(nextprops){
        if(nextprops != this.props){
            //get wallet USD 
            const { wallet } = nextprops ; 
    
            if(wallet.userwallet && wallet.userwallet.length > 0){
                wallet.userwallet.find((obj) => { 
                    if(obj.currency === 'USD') {
                        this.setState ({
                            walletUSD : obj.balance 
                        }) 
                    }
                })
            }
        }
    }

    
    onFetchData(state , instance){
        const { authentication } = this.props;

        state.page += 1;    //fix react table state started from one 
        
        transactionService.getMemberHWGCashTransactionList(state.page , state.pageSize , authentication.user.id)
        .then(response => {
            if(response){
                //update state with list 
                this.setState({
                    list : response.list , 
                    pages : response.pages , 
                    list_loading : false
                })
            }
        })
    }

    handleCurrencyDropdown(event){
    }
    
    handleHWGCashChange(event){
        this.setState ({
            conversion : event.target.value , 
            [event.target.name] : event.target.value   
        })
    }

    handleChange(event){

        this.setState ({
            [event.target.name] : event.target.value  
        })
    }

    handleSubmit(event){
        event.preventDefault();
        
        const { walletUSD , amount } = this.state ; 
        const { authentication } = this.props;

        if(walletUSD < amount){

            Alert.error("Insufficient USD amount in wallet to get HWG Cash", {
                position: 'bottom-right' , 
                effect : 'flip'
            });

            return false ; 
        }

        let formBody = {
            amount : amount , 
            memberId : authentication.user.id
        }

        this.setState({
            disableSubmit : true
        });

        transactionService.createMemberHWGCashDeposit(formBody);
    
    }

    handleUploadFile (event){
        let file = event.target.files[0];

        if(file){
            this.setState ({
                filename : file.name ,
                file : file 
            });
        }
    }

    render(){
        
        const {loading , wallet} = this.props;
        const { amount , conversion , walletUSD , list , pages , list_loading } = this.state;

        const disableSubmit = this.state.disableSubmit ? 'disabled' : '' ;  

        //define table columns 
        const columns = [
            {
                Header: 'Currency',
                accessor: 'currency'  
            }, 
            {
                Header: 'Qty / Amount',
                accessor: 'amount'  
            }, 
            {
                Header: 'Order Date',
                accessor: 'createdstr'  
            }, 
            {
                Header: 'Status',
                accessor: 'status' , 
                Cell: row => (
                    <span className={`tag is-${row.value}`}>
                       {row.value}
                    </span>
                )  
            }, 
        ]


        return (
            <section className="section m-t-xs m-b-lg">
                
                <div className="columns is-mobile border-bottom p-b-xs">
                    <div className="column is-6-desktop is-6-mobile"> </div>
                    <div className="column is-6-desktop is-6-mobile is-clearfix p-t-md">
                        <div className="columns exchangeheader">

                            <h6 className="column v-centered border-right-bold light">Wallet</h6>
                            {
                                wallet.userwallet && (
                                    Array.isArray(wallet.userwallet) && 
                                    wallet.userwallet.map((walletitem)=>{
                                        return (
                                            <div key={walletitem.currency} className="column border-right p-l-md">
                                                <span className="light-text">{walletitem.currency}</span> 
                                                <br/>
                                                <h6 className="light">{utils.addZeroes(walletitem.balance.toString())}</h6>
                                            </div>
                                        )
                                    })
                                )
                            }

                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="columns">
                        <div className="column is-6">
                            <form onSubmit={this.handleSubmit} className="default-form is-clearfix">
                                <h4>Get HWG CASH Form</h4>

                                <div className="field is-horizontal m-t-lg">
                                    <div className="field-label is-small">
                                        <label className="label">HWG Cash QTY</label>
                                    </div>
                                    <div className="field-body columns">
                                        <div className="column is-6">
                                            <input className="input is-small" onChange={this.handleHWGCashChange} name="amount" value={amount} type="text" placeholder="Input amount" /> 
                                        </div>
                                        <div className="column is-6">
                                            <label className="label"> : &nbsp; {conversion} USD</label> 
                                        </div>
                                    </div>
                                </div>
                                
                                <div className='form-info m-b-md'>
                                    <div className="field is-horizontal">
                                            <div className="field-label is-small">
                                                <label className="label">My Wallet USD</label>
                                            </div>
                                            <div className="field-body">
                                                {walletUSD}
                                            </div>
                                        </div>
                                </div>
                                
                                <div className="control m-t-lg is-pulled-right">
                                    <input type="submit" disabled={disableSubmit} className="button button-submit" value="Get HWG Cash"/>
                                </div>
                            </form>
                        </div>
                        
                        <div className="column is-6">
                            <h4>Get HWG Cash Orders</h4>
                            
                            <div className=" m-t-md">
                                <ReactTable
                                    manual
                                    data={list}
                                    pages={pages}
                                    loading={list_loading}
                                    columns={columns}
                                    defaultPageSize = {5} 
                                    onFetchData = {this.onFetchData}
                                    className="-striped -highlight"
                                    NoDataComponent = { ()=> { return []} }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

function mapStateToProps(state) {
    const { authentication , wallet } = state;

    return {
        authentication , wallet
    };
}

const connectedPage = connect(mapStateToProps)(GetHWGCashPage);
export { connectedPage as GetHWGCashPage }; 



// WEBPACK FOOTER //
// ./src/Views/HWGCashPage/GetHWGCashPage.jsx